import { queryOptions, useQuery } from "@tanstack/react-query";
import { documentosApi } from "@/features/documentos/services/documentos.api";
import { qk } from "@/lib/query-keys";
import type { DocumentoApi, DocumentoVinculado } from "@/lib/types";

/** Documento de Gestión Documental en la forma que pintan las filas del paso «Documentos». */
export function aDocumentoVinculado(doc: DocumentoApi): DocumentoVinculado {
  return {
    id: doc.id,
    documentoId: doc.id,
    categoria: doc.categoria,
    nombreOriginal: doc.nombreOriginal,
    vinculadoAt: doc.cargadoAt,
    tipoDocumento: doc.tipoDocumento ?? null,
    numeroCfdi: doc.numeroCfdi,
  };
}

/**
 * Documentos de la solicitud · Gestión Documental es la ÚNICA fuente (se retiró la copia
 * `documentos_vinculados` del CORE): un documento recién subido ya viene en la respuesta del
 * servidor, sin esperar al outbox.
 */
export const documentosSolicitudQueryOptions = (solicitudId: string) =>
  queryOptions({
    queryKey: qk.documentosSolicitud(solicitudId),
    queryFn: async () =>
      (await documentosApi.listar(solicitudId))
        .map(aDocumentoVinculado)
        .sort((a, b) => a.vinculadoAt.localeCompare(b.vinculadoAt)),
  });

/** Intervalo de refresco fijo, o calculado a partir de la última lista recibida. */
type IntervaloDocumentos = number | false | ((documentos: DocumentoVinculado[] | undefined) => number | false);

export function useDocumentosSolicitud(solicitudId: string, options?: { refetchInterval?: IntervaloDocumentos }) {
  const intervalo = options?.refetchInterval ?? false;
  return useQuery({
    ...documentosSolicitudQueryOptions(solicitudId),
    refetchInterval: typeof intervalo === "function" ? (q) => intervalo(q.state.data) : intervalo,
  });
}
